<template>
  <div v-if="alerts.length > 0" class="col-xs-12">
    <div class="alert alert-info" role="alert">
      <ul>
        <li v-for="alert in alerts" :key="alert.Key">{{alert.Value}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      alerts: [],
      interval: null
    };
  },
  mounted() {
    this.getAlerts();

    this.interval = setInterval(() => {
      this.getAlerts();
    }, /* 5 min */ 1000 * 60 * 5)
  },
  beforeDestroy() {
    if(this.interval) clearInterval(this.interval);
  },
  methods: {
      getAlerts() {
          this.alerts = [];
      axios
          .get(process.env.VUE_APP_ROOT_API + "KeyValueStore/GetAll", { withCredentials: true })
        .then(response => {
          this.alerts = response.data;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>